module.exports = __webpack_public_path__ + "img/block01.be722457.webp";